import _ from 'lodash';

import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function runTaskCommand({ route, httpMethod = 'get', data = {}, ...params }) {
  return request[_.toLower(httpMethod)](`/${route}`, {
    ...(_.toLower(httpMethod) === 'post' && { data }),
    params: toQuery(params),
  });
}
